import React from 'react';

import PropTypes from 'prop-types';
import { ExpandCollapse, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { FilterGridContainer } from './css';
import request from '../../../../utils/request';
import { orderStatus } from '../../../../utils/constant';

import FilterByProduct from './components/filterByProduct';
import FilterByStatus from './components/filterByStatus';
import FilterByFlag from './components/filterByFlag';
import FilterByAssignee from './components/filterByAssignee';
import FilterBySalesRep from './components/filterBySalesRep';
import FilterByProvince from './components/filterByProvince';
import FilterByChannel from './components/filterByChannel';
import FilterByDealership from './components/filterByDealership';
import FilterByDates from './components/filterByDates';
import ActionButtons from './components/actionButtons';

const Filters = ({
  setOrders,
  filters,
  setFilters,
  getPayload,
  includeIncompleteStatus,
  setPageNumber
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filtersDropdownTitle }
  } = localizedStrings;

  const {
    incomplete,
    pendingValidation,
    waitingOnCredit,
    waitingOnSales,
    contractSigned,
    contractSent,
    orderCanceled,
    contractExpired,
    orderInstalled,
    orderPlaced,
    orderActivated,
    orderShipped,
    orderCompleted
  } = orderStatus;

  const onApplyFilters = (resetFilters = false) => {
    let payload = getPayload();

    if (resetFilters) {
      const resetFiltersPayload = {
        iotProductSelected: '',
        status: '',
        flag: '',
        assignedUserId: '',
        createdBy: '',
        province: '',
        channelId: '',
        dealership: '',
        filterCriteria: '',
        startDate: '',
        endDate: ''
      };
      setFilters(resetFiltersPayload);
      payload = {
        ...payload,
        ...resetFiltersPayload,
        status: [
          ...(includeIncompleteStatus ? [incomplete] : []),
          pendingValidation,
          waitingOnCredit,
          waitingOnSales,
          contractSigned,
          contractSent,
          orderCanceled,
          contractExpired,
          orderInstalled,
          orderPlaced,
          orderActivated,
          orderShipped,
          orderCompleted
        ]
      };
    }
    setPageNumber(1);
    request
      .post('/orders/filter', payload)
      .then(response => {
        setOrders(response);
      })
      .catch(() => {});
  };

  return (
    <ExpandCollapse initialOpen={[]} topDivider={false}>
      {(expandProps) => (
      <ExpandCollapse.Panel
          {...expandProps}
          panelId="filters" control={<Typography heading="h3" variant={{ size: 'h3', bold: true }}>{filtersDropdownTitle}</Typography>}>
        <FilterGridContainer>
          <FilterByProduct filters={filters} setFilters={setFilters} />
          <FilterByStatus
            filters={filters}
            setFilters={setFilters}
            includeIncompleteStatus={includeIncompleteStatus}
          />
          <FilterByFlag filters={filters} setFilters={setFilters} />
          <FilterByAssignee filters={filters} setFilters={setFilters} />
          <FilterBySalesRep filters={filters} setFilters={setFilters} />
          <FilterByProvince filters={filters} setFilters={setFilters} />
          <FilterByChannel filters={filters} setFilters={setFilters} />
          <FilterByDealership filters={filters} setFilters={setFilters} />
          <FilterByDates filters={filters} setFilters={setFilters} />
        </FilterGridContainer>
        <ActionButtons onApplyFilters={onApplyFilters} />
      </ExpandCollapse.Panel>
          )}
    </ExpandCollapse>
  );
};

Filters.propTypes = {
  filters: PropTypes.objectOf(
    PropTypes.shape({
      status: PropTypes.string,
      flag: PropTypes.string,
      assignedUserId: PropTypes.number,
      createdBy: PropTypes.number,
      province: PropTypes.arrayOf(PropTypes.string),
      channelId: PropTypes.arrayOf(PropTypes.string),
      filterCriteria: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string
    })
  ).isRequired,
  setFilters: PropTypes.func.isRequired,
  setOrders: PropTypes.func.isRequired,
  getPayload: PropTypes.func.isRequired,
  includeIncompleteStatus: PropTypes.bool.isRequired,
  setPageNumber: PropTypes.func.isRequired
};

export default Filters;
